import React from 'react';

const getValidChildren = (children: React.ReactNode) =>
  React.Children.toArray(children).filter((child) =>
    React.isValidElement(child)
  );

export const isReactChildrenValid = (children: React.ReactNode) =>
  !!React.Children.count(getValidChildren(children));
